import { AxiosResponse } from 'axios'
import SecureClient from '../SecureClient'
import { EventHandler } from './DTO'

export default class EventHandlersClient extends SecureClient {
	/**
	 * get all the available configurable event handlers
	 * @returns all available configurable event handlers
	 */
	public getEventHandlers = (): Promise<
		AxiosResponse<EventHandler[]>
	> => {
		return this._api.get<EventHandler[]>('EventHandlers', {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader(),
			},
		})
	}

	/**
	 * get one configurable event handler
	 * @param eventHandlerId 
	 * @returns the configurable event handler if it exists
	 */
	public getEventHandler = (
		eventHandlerId: string,
	): Promise<AxiosResponse<EventHandler>> => {
		return this._api.get<EventHandler>(
			`EventHandlers/${eventHandlerId}`,
			{
				headers: {
					...this.acceptHeader(),
					...this.contentTypeHeader(),
				},
			},
		)
	}
}
